"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorWithEmailViewContainer = void 0;
var _authentication = require("../../actions/authentication");
var _events = require("../../actions/events");
var _selectors = require("./selectors");
var _TwoFactorWithEmailViewContainer = require("./TwoFactorWithEmailViewContainer");
var _reactRedux = require("react-redux");
var _view = require("../../actions/view");
function mapStateToProps(state) {
  return {
    isSubmitting: (0, _selectors.isSubmittingSelector)(state),
    hasCodeError: (0, _selectors.hasCodeErrorSelector)(state),
    codeError: (0, _selectors.codeErrorSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    authenticate(params) {
      dispatch((0, _authentication.authenticate)(params));
    },
    emit(type, event) {
      dispatch((0, _events.emit)(type, event));
    },
    reset() {
      dispatch((0, _authentication.reset)());
    },
    changeView(view) {
      dispatch((0, _view.changeView)(view));
    }
  };
}
const TwoFactorWithEmailViewContainer = exports.TwoFactorWithEmailViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TwoFactorWithEmailViewContainer.TwoFactorWithEmailViewContainer);